import CommonProcess from 'app/components/OrderPayment/Common/CommonProcess';
import React from 'react';

const KCPPaymentMob = () => {
  return <CommonProcess />;
};

export default KCPPaymentMob;
